import assert from './assert'

/**
 * Used within the global nav to highlight the destinations nav item.
 */
export const warehousesNavPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/warehouses`
}

export const warehousesPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/destinations#warehouses`
}

export const warehousePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/overview`
}

export const warehouseSettingsPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings`
}

export const warehouseSettingsConnectionPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings/connection`
}

export const warehouseSettingsSyncPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings/sync`
}

export const warehouseSettingsSyncSchedulePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings/sync-schedule`
}

export const warehouseSettingsMaintenancePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings/maintenance`
}

export const warehouseSourceOverviewPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sources/${args.sourceId}/overview`
}

export const warehouseSourceSyncHistoryPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sources/${args.sourceId}/sync-history`
}

export const warehouseSourceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sources/${args.sourceId}/settings`
}

export const warehouseSourceSyncHistoryRunPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId', 'runId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sources/${args.sourceId}/sync-history/${args.runId}`
}
